import { render, staticRenderFns } from "./positiveList.vue?vue&type=template&id=3ddb16d4&scoped=true"
import script from "./positiveList.vue?vue&type=script&lang=js"
export * from "./positiveList.vue?vue&type=script&lang=js"
import style0 from "./positiveList.vue?vue&type=style&index=0&id=3ddb16d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddb16d4",
  null
  
)

export default component.exports